import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";
import useSelectedAmenities
    from "@CheckOrder/features/amenities/features/countAmenity/features/list/hooks/useSelectedAmenities";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import useSumAmenities from "@CheckOrder/features/amenities/hooks/useSumAmenities";
import getGroupTranslationAndIcon
    from "@CheckOrder/features/amenities/features/countAmenity/functions/getGroupTranslationAndIcon";
import useGetAmenitiesCurrency from "@CheckOrder/features/amenities/hooks/useGetAmenitiesCurrency";
import {CountAmenityType} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenity.type";
import PriceFractionDisplay from "@CheckOrder/features/paymentSummary/components/PriceFractionDisplay";

interface AmenityGroupSummaryProps {
    pairedAmenityGroups: PairedSingleAndReturnAmenitiesType
}

function AmenityGroupSummary({pairedAmenityGroups}: AmenityGroupSummaryProps) {
    const {translations: {groupName}} = getGroupTranslationAndIcon(pairedAmenityGroups)
    const {
        isReturn,
    } = useAppSelector((state) => (state.checkOrder.ticket))

    const {code} = useGetAmenitiesCurrency() || {}

    const {
        selectedSingleAmenities,
        selectedReturnAmenities,
    } = useSelectedAmenities(pairedAmenityGroups)

    const {sumAmenities} = useSumAmenities()
    const getAmenities = (selectedAmenities: Record<string, CountAmenityType>) => (Object.entries(selectedAmenities).map(([_key, amenity]) => (amenity)))

    return (
        <>
            {!!Object.keys(selectedSingleAmenities).length && (
                <PriceFractionDisplay
                    fractionTitle={isReturn ? `Outbound ${groupName.toLowerCase()}` : groupName}
                    price={`${sumAmenities(getAmenities(selectedSingleAmenities), "single")} ${code}`}
                />
            )}
            {isReturn && !!Object.keys(selectedReturnAmenities).length && (
                <PriceFractionDisplay
                    fractionTitle={`Return ${groupName.toLowerCase()}`}
                    price={`${sumAmenities(getAmenities(selectedReturnAmenities), "return")} ${code}`}
                />
            )}
        </>
    )
}

export default AmenityGroupSummary